import { apiFetch, AI_ANALYSIS_TIMEOUT_MS } from './client';

export type GeoCategoryId =
  | 'mercados'
  | 'farmacias'
  | 'escolas'
  | 'hospitais'
  | 'postos_saude'
  | 'parques'
  | 'pracas'
  | 'lagoas'
  | 'praias'
  | 'ciclovias'
  | 'academias'
  | 'shopping'
  | 'transporte_publico';

export interface GeoCoordinates {
  lat: number;
  lng: number;
}

export interface GeoPlace {
  id: string;
  name: string;
  lat: number;
  lng: number;
  distanceMeters: number;
  source: 'google' | 'osm';
  category: GeoCategoryId;
  address?: string;
  types?: string[];
}

export interface GeoCategorySummary {
  count: number;
  nearestDistanceMeters: number | null;
}

export interface GeoCategoryResult {
  category: GeoCategoryId;
  label: string;
  summary: GeoCategorySummary;
  places: GeoPlace[];
}

export interface GeoAnalysisScores {
  walkability: number;
  infrastructure: number;
  overall: number;
}

export interface GeoAnalysisMeta {
  providers: Array<'google_maps' | 'openstreetmap'>;
  cacheHit: boolean;
  radiusMeters: number;
  durationMs: number;
  googleApiCalls: number;
}

export interface GeoAnalysisResult {
  address: string;
  formattedAddress?: string;
  coordinates: GeoCoordinates;
  radiusMeters: number;
  analyzedAt: string;
  categories: GeoCategoryResult[];
  summary: Record<GeoCategoryId, GeoCategorySummary>;
  scores: GeoAnalysisScores;
  meta: GeoAnalysisMeta;
}

export interface AnalyzeLocationParams {
  address: string;
  radius?: number;
}

export const geoAnalysisApi = {
  analyzeLocation(params: AnalyzeLocationParams): Promise<GeoAnalysisResult> {
    return apiFetch<GeoAnalysisResult>('/analyze-location', {
      method: 'POST',
      body: {
        address: params.address,
        radius: params.radius ?? 800,
      },
      skipAuth: true,
      // Geo-análise faz chamadas externas (Google/OSM) + IA; pode passar de 30s.
      timeoutMs: AI_ANALYSIS_TIMEOUT_MS,
    });
  },
};
